import React from   'react';
import PropTypes from 'prop-types';
import { ButtonGroup, Button, DropdownButton, Dropdown } from 'react-bootstrap';

const RecepcionHeaderEstadoDXdia = ({
    datosFecha = {},
    sedes = [],
    actionSedes,
    AbrirFormularioRecepcion,
    sedeActual,
    showSelectSede = false,
    cantidadManual = 0,
    ActualizarCantidadManual = () => {},
    Profesionales = [],
}) => {
    if (Profesionales === undefined) {
        Profesionales = [];
    }
    if (cantidadManual === undefined) {
        cantidadManual = 0;
    }
    if (ActualizarCantidadManual === undefined) {
        ActualizarCantidadManual = () => {};
    }
    const [showProfesionales, setShowProfesionales] = React.useState(false);
    async function buscarDatosRecepcion(action) {
        debugger
        actionSedes(action)
    }
    // container styles to make buttons responsive (wrap on small screens)
    const containerStyle = {
        position: 'absolute',
        top: '100%',
        right: 0,
        zIndex: 1000,
        background: '#fff',
        border: '1px solid #ccc',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        padding: '8px',
        minWidth: '200px'
    };

    const arrayButtons = [
        { label: 'Familias del dia', value: datosFecha.familiasdia },
        { label: 'Pendientes', value: datosFecha.familiaspendientes },
        { label: 'En atención', value: datosFecha.familiasenatencion },
        { label: 'Atendidos', value: datosFecha.familiasatendidas },
        { label: 'Bloqueados', value: datosFecha.familiasbloqueadas },
        { label: 'Anulados', value: datosFecha.familiasanuladas }
    ];

    return (
        <div className="box-header float-sm-left" style={{ position: 'relative', gap: '10px', display: 'flex', flexWrap: 'wrap' }}>
            <ButtonGroup aria-label="Header actions" style={{ marginBottom: 8 }}>
                {AbrirFormularioRecepcion && (
                    <Button
                        id="nuevaPersona"
                        onClick={() => AbrirFormularioRecepcion({sede : sedeActual, id : '0'})}
                    >
                        Crear recepci&oacute;n
                    </Button>
                )}
                {showSelectSede && (
                    <DropdownButton as={ButtonGroup} 
                        title={sedes.find(item => item.id === sedeActual)?.sedNombre || 'Sede'} 
                        id="bg-nested-dropdown"
                        >
                        {sedes.map((item) => (
                            <Dropdown.Item key={item.sedNombre} eventKey={item.sedNombre} onClick={() => actionSedes(item)}>
                                {item.sedNombre}
                            </Dropdown.Item>
                        ))}
                    </DropdownButton>
                )}
                <Button style={{ width: '10%' }}>
                    Actas recibidas {' '}
                    <i className="fa" style={{ backgroundColor: 'white' }}>
                        <input
                            type="number"
                            value={cantidadManual}
                            onChange={ActualizarCantidadManual}
                            aria-label="Cantidad manual"
                            style={{
                                border: 'none',
                                outline: 'none',
                                background: 'transparent',
                                width: '100%',
                                textAlign: 'center',
                                fontSize: '1rem',
                            }}
                        />
                    </i>
                </Button>
                
                {arrayButtons.map((element) => (
                    <Button key={element.label} style={{ width: '10%' }}>
                        {element.label}{' '}
                        <i className="fa" style={{ backgroundColor: 'white' }}>
                            <input
                                type="number"
                                value={element.value ?? 0}
                                readOnly
                                aria-label="Cantidad manual"
                                style={{
                                    border: 'none',
                                    outline: 'none',
                                    background: 'transparent',
                                    width: '100%',
                                    textAlign: 'center',
                                    fontSize: '1rem',
                                }}
                            />
                        </i>
                    </Button>
                ))}

                <Button
                    style={{ width: '10%' }}
                    onMouseEnter={() => setShowProfesionales(true)}
                    onMouseLeave={() => setShowProfesionales(false)}
                >
                    Cant. profesionales {' '}
                    <i className="fa" style={{ backgroundColor: 'white' }}>
                        <input
                            type="number"
                            value={Profesionales.length}
                            readOnly
                            aria-label="Cantidad manual"
                            style={{
                                border: 'none',
                                outline: 'none',
                                background: 'transparent',
                                width: '100%',
                                textAlign: 'center',
                                fontSize: '1rem',
                            }}
                        />
                    </i>
                </Button>
            </ButtonGroup>
         {showProfesionales && Profesionales.length > 0 && (
             <div
                 style={{ ...containerStyle }}
                 onMouseEnter={() => setShowProfesionales(true)}
                 onMouseLeave={() => setShowProfesionales(false)}
                 onKeyDown={e => {
                     if (e.key === 'Escape') setShowProfesionales(false);
                 }}
             >
                 <b>Profesionales:</b>
                 <select
                     aria-label="Lista de profesionales"
                     multiple
                     size={Math.min(Profesionales.length, 8)}
                     readOnly
                     style={{ width: '100%', marginTop: '6px' }}
                 >
                     {Profesionales.map((p, idx) => (
                         <option key={idx}>
                             {typeof p === 'object'
                                 ? p.pro_nombre || p.nombre || JSON.stringify(p)
                                 : p}
                         </option>
                     ))}
                 </select>
             </div>
         )}
        </div>
    );
  };
RecepcionHeaderEstadoDXdia.propTypes = {
  datosFecha: PropTypes.object,
  sedes: PropTypes.arrayOf(PropTypes.shape({
    sedNombre: PropTypes.string
  })),
  actionSedes: PropTypes.func,
  AbrirFormularioRecepcion: PropTypes.func,
  sedeActual: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showSelectSede: PropTypes.bool,
  cantidadManual: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ActualizarCantidadManual: PropTypes.func,
  Profesionales: PropTypes.array
};

export default RecepcionHeaderEstadoDXdia;
